export default __webpack_public_path__ + "static/media/mac.d02ba9a5.png";